import React, {PureComponent} from 'react';
import Dropzone from 'react-dropzone';
import intl from 'react-intl-universal';

import {BarTab, Tab, TabContent} from 'components/BarTab';
import {Button, InputField} from '..';
import {MAX_UPLOAD_SIZE, MAX_UPLOAD_COUNT} from 'constants/images';
import CloseIcon from 'assets/icons/close.svg';

import styles from './styles';

export default class ImagePicker extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      urlCount: 1,
      showRed: false,
      clickedCross: false
    };
  }
  componentDidMount = () => {
    document.body.addEventListener("dragover", function() {
      if(!document.getElementsByClassName('picker-content')[0].classList.contains('dragging')) {
        document.getElementsByClassName('picker-content')[0].classList.add('dragging');
      }
    });

    document.body.addEventListener("dragleave", function() {
      if(document.getElementsByClassName('picker-content')[0].classList.contains('dragging')) {
        document.getElementsByClassName('picker-content')[0].classList.remove('dragging');
      }
    });
  };
  componentDidUpdate = (prevProps, prevState) => {
    if(this.props.disabled) {
      if(this.state.clickedCross) {
        this.setState({clickedCross: false});
      } else if(!prevState.clickedCross) {
        this.setState({showRed: true});
      }
    }
  }
  handleImageDrop = (acceptedFiles, rejectedFiles) => {
    const {dropImages, disabled} = this.props;

    if (!disabled) {
      dropImages(acceptedFiles, rejectedFiles);
    }
  };

  handleUrlInputChange = ({ target: { name, value } }) => {
    const {changeUrl} = this.props;

    changeUrl(name, value);
  };

  handleAddMoreUrls = () => this.setState(({ urlCount }) => ({
    urlCount: urlCount + 1
  }));

  renderFormFields() {
    const {multiple, submitUrlUpload} = this.props;
    const {urlCount} = this.state;
    const inputProps = {
      placeholder: 'http://',
      onChange: this.handleUrlInputChange
    };

    if (multiple) {
      return (
        <div className={styles.multipleFormInputs}>
          {Array(urlCount).fill(0).map((_, idx) =>
            <InputField
              className={styles.siblingInput}
              key={ `url-${idx}` }
              name={ `url-${idx}` }
              { ...inputProps }
            />
          )}
          <Button className='accent-button' onClick={this.handleAddMoreUrls} disabled={this.props.disabled}>
            {intl.get('Add more URLs')}
          </Button>
        </div>
      );
    }

    return (
      <InputField
        buttonText={intl.get("Resize")}
        name="url"
        handleSubmit={ submitUrlUpload }
        { ...inputProps }
      />
    );
  }
  removeLimitMsg = () => this.props.clearLimitReachMsg()

  render() {
    const {
      buttonText,
      multiple = false,
      disabled = false,
      uploading = false,
      accept = '*',
      fileType,
      maxLimitReached = false
    } = this.props;
    const classes = [];

    if (multiple) {
      classes.push(styles.imagePickerMultiple);
    }

    if (!uploading && disabled) {
      classes.push(styles.imagePickerDisabled);
    }
    if (maxLimitReached) {
      classes.push(styles.withLimitMsg);
    }
    var drag = 'Drag ' + (fileType || 'PDF') + (multiple ? 's' : '') + ' here';
    var alt = `Scroll down & click "Compress ${fileType || 'PDF'}s" to start compressing` ;
    let btnTxt = buttonText || (multiple ? 'Choose Images to Resize' : 'Choose an Image to Resize');
    console.log('btn', btnTxt);
    return (
      <div className={ classes.join(' ') }>
        <p className={styles.message}>
          <span className={styles.closeBtn} onClick={this.removeLimitMsg}>
            <CloseIcon height="20" width="20" />
          </span>
          {intl.get(`Up to ${MAX_UPLOAD_COUNT} ${fileType || 'PDF'}s`)}
        </p>
        <BarTab>
          <Tab id='computer'>{intl.get('Computer')}</Tab>
          <Tab id='url'>{intl.get('URL')}</Tab>

          <TabContent id='computer'>
            <Dropzone
              disableClick
              disablePreview
              disabled={disabled}
              ref='dropzone'
              className='picker-content'
              activeClassName='dragging'
              onDrop={this.handleImageDrop}
              maxSize={MAX_UPLOAD_SIZE}
              multiple={multiple}
              accept={accept}
            >
              <h4>{intl.get(drag)}</h4>
              <p>{intl.get('or, if u prefer')}</p>
              <Button
                className='accent-button'
                disabled={disabled}
                alt={disabled ? intl.get(alt): ''}
                title={disabled ? intl.get(alt): ''}
                onClick={() => this.refs.dropzone.open()}
              >
                {intl.get(btnTxt)}
              </Button>
            </Dropzone>
          </TabContent>

          <TabContent id='url'>
            <div className='picker-content form-group left'>
              <label className='form-label' htmlFor='url'>{intl.get(`INSERT ${fileType || 'PDF'} URL HERE`)}:</label>
              {this.renderFormFields()}
            </div>
          </TabContent>
        </BarTab>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImagePicker/index.jsx